import { ProfileService } from "@app/applications/profile/services/profile.service";
import { Component, OnInit, inject, input } from "@angular/core";
import { ProfileFormModel } from "../../models/profile-form.model";
import { IProfileEntity, IUpdateProfileDto } from "../../interfaces/profile-controls.interface";
import { ProfileFormComponent } from "../../components/profile-form/profile-form.component";
import { SxwFormComponent } from "@app/kernel/form/components/sxw-form/sxw-form.component";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { MessageService } from "@app/kernel/tools/message/service/message.service";

@Component({
  selector: "app-profile",
  imports: [ProfileFormComponent, SxwFormComponent, RouterModule, TranslateModule],
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"],
  providers: [ProfileFormModel, ProfileService],
})
export class ProfileComponent implements OnInit {
  public readonly user = input.required<IProfileEntity>();
  public router = inject(Router);
  public translate = inject(TranslateService);
  public route = inject(ActivatedRoute);
  public readonly formModel = inject(ProfileFormModel);
  private ProfileService = inject(ProfileService);
  private messageService = inject(MessageService);

  ngOnInit(): void {
    const userEntity = this.user();
    this.formModel.setEntity({
      ...userEntity,
      name: userEntity.name?.trim() ?? "",
      surname: userEntity.surname?.trim() ?? "",
      email: userEntity.email?.trim() ?? "",
      mobile: userEntity.mobile?.trim() ?? "",
    });
    this.route.queryParams.subscribe(params => {
      if (params["emailUpdated"] === "true") {
        this.refreshProfileData();
      }
    });
  }

  private refreshProfileData(): void {
    this.ProfileService.getProfile().subscribe({
      next: (profileData: IProfileEntity) => {
        this.formModel.setEntity({
          ...profileData,
          name: profileData.name?.trim() ?? "",
          surname: profileData.surname?.trim() ?? "",
          email: profileData.email?.trim() ?? "",
          mobile: profileData.mobile?.trim() ?? "",
        });
      },
    });
  }
  saveProfileChanges() {
    const formValue = this.formModel.formGroup().getRawValue();
    const dto: IUpdateProfileDto = {
      name: formValue.name,
      surname: formValue.surname,
    };
    this.ProfileService.updateMyProfile(dto).subscribe({
      next: () => this.messageService.success("profile updated successfully"),
      error: err => console.error("Error:", err),
    });
  }

  openResetPasswordPopup() {
    this.router.navigate([{ outlets: { popups: ["reset-password"] } }], { relativeTo: this.route });
  }
  openDeleteAccountpopup() {
    this.router.navigate([{ outlets: { popups: ["delete-account"] } }], { relativeTo: this.route });
  }
  onUpdateEmail() {
    this.router.navigate([{ outlets: { popups: ["update-email"] } }], { relativeTo: this.route });
  }
}
